import { getAPIGatewayDataFromParent } from '../../handler/ParentDataHandler';
import { getStationCode, getCurrentTime, logOperationalMetric, METRIC_PROCESS_NAME_SCRUB } from "../../util/CommonUtils";




 const APIGatewayLink = async ({url, method, body}) => {

    const request = {
        resourcePath: `/nevs/nevs/${url}`,
        httpMethod: method,
        processName: "exceptions",
        requestBody: body
    }

    const response = await getAPIGatewayDataFromParent(request);
    if (response.status === 200) {
        return {
            valid: true,
            data: response.data
        }
    } else {
        return {
            valid: false,
            data: {},
            errorCode: response.status
        };
    }
}

const endpoints = {
    GET_SCRUB_SHIPMENTS: "getScrubShipmentsDetails",
    GET_SCRUB_STATS: "getScrubShipments",
    UPDATE_SCRUB_SHIPMENTS_STATUS: "updateScrubShipmentsStatus",
    INVOKE_SCRUB: "invokeScrub",
    GET_SCRUB_INVOCATION_DETAILS: "getScrubInvocationDetails",
    GET_FEATURE_STATUS: "getFeatureStatus",
    GET_SCRUB_START_ELIGIBILITY: "getStartScrubEligibility",
    GET_EXCEPTION_SHIPMENTS: "getExceptionShipments",
    UPDATE_SCRUB_SHIPMENTS: "updateScrubShipments",
    UPDATE_STATUS: "selectiveMarkingStatusUpdate"
};

const CallAPI  = async (endpoint, httpVerb, args) => {
    const startTime = getCurrentTime();
    const response = await APIGatewayLink({
        url: endpoint,
        method: httpVerb,
        body: args
    });
    logOperationalMetric(startTime,
        METRIC_PROCESS_NAME_SCRUB,
        endpoint,
        response.valid);
    return response;
};


export const ExceptionsClient = {

    getScrubShipmentsForCategory: async (args) => {
        return await CallAPI(endpoints.GET_SCRUB_SHIPMENTS,
            "post",
            {...args, ...getStationCode()});
    },

    getScrubStats: async (args) => {
        return await CallAPI(endpoints.GET_SCRUB_STATS,
            "post",
            {...args, ...getStationCode()});
    },

    markForScrub: async (args) => {
        return await CallAPI(endpoints.UPDATE_SCRUB_SHIPMENTS_STATUS,
            "post",
            {...args, ...getStationCode()});
    },

    invokeScrub: async (args) => {
        return await CallAPI(endpoints.INVOKE_SCRUB,
            "post",
            {...args, ...getStationCode()});
    },

    getScrubInvocationDetails: async (args) => {
        return await CallAPI(endpoints.GET_SCRUB_INVOCATION_DETAILS,
            "post",
            {...args, ...getStationCode()});
    },
    getFeatureStatus: async (args) => {
        return await CallAPI(endpoints.GET_FEATURE_STATUS,
            "post",
            {...args, ...getStationCode()});
    },

    getStartScrubEligibility: async (args) => {
        return await CallAPI(endpoints.GET_SCRUB_START_ELIGIBILITY,
            "post",
            {...args, ...getStationCode()});
    },

    getExceptionShipments: async (args) => {
        return await CallAPI(endpoints.GET_EXCEPTION_SHIPMENTS,
            "post",
            {...args, ...getStationCode()})
    },

    updateScrubShipments: async(args) => {
        return await CallAPI(endpoints.UPDATE_SCRUB_SHIPMENTS,
            "post",
            {...args, ...getStationCode()})
    },

    updateTerminalScan: async(args) => {
        return await CallAPI(endpoints.UPDATE_STATUS,
            "post",
            {...args, ...getStationCode()})
    }
};


// WEBPACK FOOTER //
// ./src/commons/client/ExceptionsClient.js